export const isRequired = (value: string): boolean => value.trim().length > 0;

export const minLength = (value: string, length: number): boolean =>
  value.trim().length >= length;

export const isValidEmail = (value: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
};

export const isOnlyDigits = (value: string): boolean => /^\+?\d+$/.test(value);

export const isExactLength = (value: string, length: number): boolean =>
  value.length === length;

export const isValidPassword = (value: string): boolean => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
  return passwordRegex.test(value);
};

export const doPasswordsMatch = (
  password: string,
  confirmPassword: string
): boolean => password === confirmPassword;
